var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChurch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.905,
    x2: 302.384,
    xlinkHref: "#lg1",
    y1: 64.744,
    y2: 64.744
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.283,
    x2: 175.475,
    xlinkHref: "#lg1",
    y1: 64.744,
    y2: 64.744
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.478,
    x2: 165.164,
    xlinkHref: "#lg2",
    y1: 65.562,
    y2: 28.973
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.852,
    x2: 264.944,
    xlinkHref: "#lg2",
    y1: 54.059,
    y2: 7.544
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.869,
    x2: 297.77,
    xlinkHref: "#lg3",
    y1: 180.301,
    y2: 485.135
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.335,
    x2: 182.309,
    xlinkHref: "#lg4",
    y1: 379.312,
    y2: 119.463
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.615,
    x2: 252.204,
    xlinkHref: "#lg4",
    y1: 386.42,
    y2: 192.328
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#a26c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 359.349,
    y2: 540.645
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.277,
    x2: 293.957,
    xlinkHref: "#lg5",
    y1: 376.498,
    y2: 531.904
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42210b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210b"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.634,
    x2: 153.395,
    xlinkHref: "#lg6",
    y1: 438.205,
    y2: 493.572
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.76,
    x2: 94.014,
    xlinkHref: "#lg3",
    y1: 373.286,
    y2: 436.585
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.998,
    x2: 62.834,
    xlinkHref: "#lg4",
    y1: 413.084,
    y2: 351.921
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.242,
    x2: 80.218,
    xlinkHref: "#lg5",
    y1: 331.388,
    y2: 384.238
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.12,
    x2: 65.12,
    xlinkHref: "#lg6",
    y1: 379.039,
    y2: 237.453
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 1 2998.804 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2515.564,
    x2: 2582.818,
    xlinkHref: "#lg3",
    y1: 373.286,
    y2: 436.585
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.458,
    x2: 389.958,
    xlinkHref: "#lg4",
    y1: 411.488,
    y2: 411.488
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-1 0 0 1 2998.804 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2535.046,
    x2: 2569.022,
    xlinkHref: "#lg5",
    y1: 331.388,
    y2: 384.238
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.88,
    x2: 444.88,
    xlinkHref: "#lg6",
    y1: 379.039,
    y2: 237.453
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 118.34,
    y2: 328.939
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 297.654,
    y2: -60.062
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.012,
    x2: 158.917,
    xlinkHref: "#lg6",
    y1: 163.31,
    y2: 101.022
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.248,
    x2: 306.124,
    xlinkHref: "#lg5",
    y1: 245.331,
    y2: 319.207
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.79,
    x2: 262.754,
    xlinkHref: "#lg7",
    y1: 260.4,
    y2: 242.364
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.751,
    x2: 230.166,
    xlinkHref: "#lg7",
    y1: 260.166,
    y2: 242.58
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.18,
    x2: 262.395,
    xlinkHref: "#lg7",
    y1: 293.594,
    y2: 274.81
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.61,
    x2: 229.375,
    xlinkHref: "#lg7",
    y1: 293.829,
    y2: 274.593
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.932,
    x2: 219.025,
    xlinkHref: "#lg6",
    y1: 268.053,
    y2: 247.605
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.782,
    x2: 261.445,
    xlinkHref: "#lg6",
    y1: 275.881,
    y2: 225.39
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.909,
    x2: 67.713,
    xlinkHref: "#lg1",
    y1: 473.859,
    y2: 505.074
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 1 3114.334 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2664.242,
    x2: 2672.046,
    xlinkHref: "#lg1",
    y1: 473.859,
    y2: 505.074
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.872,
    x2: 143.872,
    xlinkHref: "#lg1",
    y1: 479.8,
    y2: 514.604
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(-1 0 0 1 2901.5 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 2535.372,
    x2: 2535.372,
    xlinkHref: "#lg1",
    y1: 479.8,
    y2: 514.604
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.69,
    x2: 38.178,
    xlinkHref: "#lg8",
    y1: 466.665,
    y2: 409.153
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.116,
    x2: 46.62,
    xlinkHref: "#lg7",
    y1: 457.09,
    y2: 417.595
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.438,
    x2: 417.926,
    xlinkHref: "#lg8",
    y1: 466.665,
    y2: 409.153
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.863,
    x2: 426.368,
    xlinkHref: "#lg7",
    y1: 457.09,
    y2: 417.595
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m291.892 28.059h-21.208v-24.246c0-2.106-1.707-3.813-3.813-3.813h-23.742c-2.106 0-3.813 1.707-3.813 3.813v24.247h-21.208c-2.106 0-3.813 1.707-3.813 3.813v23.742c0 2.106 1.707 3.813 3.813 3.813h21.208v66.25c0 2.106 1.707 3.813 3.813 3.813h23.742c2.106 0 3.813-1.707 3.813-3.813v-66.25h21.208c2.106 0 3.813-1.707 3.813-3.813v-23.743c-.001-2.106-1.708-3.813-3.813-3.813z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.475 120.667v-66.737c0-.918-.744-1.663-1.663-1.663h-21.695c-.918 0-1.663-.744-1.663-1.663v-13.723c0-.918.744-1.663 1.663-1.663h21.695c.918 0 1.663-.744 1.663-1.663v-24.733c0-.918.744-1.663 1.663-1.663h13.724c.918 0 1.663.744 1.663 1.663v24.733c0 .918.744 1.663 1.663 1.663h21.695c.918 0 1.663.744 1.663 1.663v13.724c0 .918-.744 1.663-1.663 1.663h-21.695c-.918 0-1.663.744-1.663 1.663v66.737c0 .918-.744 1.663-1.663 1.663h-13.724c-.918-.001-1.663-.746-1.663-1.664z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.892 28.059h-21.208v-24.246c0-2.106-1.707-3.813-3.813-3.813h-11.871v129.489h11.871c2.106 0 3.813-1.707 3.813-3.813v-66.25h21.208c2.106 0 3.813-1.707 3.813-3.813v-23.741c-.001-2.106-1.708-3.813-3.813-3.813z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.296 42.421v13.192c0 2.106 1.707 3.813 3.813 3.813h21.208v66.25c0 2.106 1.707 3.813 3.813 3.813h23.742c2.106 0 3.813-1.707 3.813-3.813v-66.25h21.208c2.106 0 3.813-1.707 3.813-3.813v-13.192z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405.53 510h-301.06v-241.602l150.53-148.171 150.53 148.171z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 120.227-150.53 148.171v24.943l216.659 216.659h84.401v-241.602z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.53 347.15-112.884-112.883c-1.249-2.692-3.968-3.563-7.131-3.563h-61.03c-4.344 0-6.864 2.521-6.864 6.864v61.03c0 3.163.871 5.882 3.563 7.131l184.346 184.346z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.007 510h-134.014v-91.364c0-35.543 28.813-64.356 64.356-64.356h5.302c35.543 0 64.356 28.813 64.356 64.356z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.94 510h-113.88v-86.511c0-31.447 25.493-56.94 56.94-56.94 31.447 0 56.94 25.493 56.94 56.94z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 366.549v143.451h56.94v-86.511c0-31.447-25.493-56.94-56.94-56.94z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.228 510h74.242v-197.024l-74.242 74.243z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.228 399.895 74.242 74.242v-161.161l-74.242 74.243z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.47 286.273-102.625 102.626c-3.941 3.941-1.15 10.68 4.424 10.68h36.086c9.036 0 17.703-3.59 24.093-9.98l38.023-38.023v-65.303z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.47 320.876v30.7l-38.024 38.024c-6.389 6.389-15.053 9.976-24.094 9.976h-16.582z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m479.772 510h-74.242v-197.024l74.242 74.243z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.772 510h-74.242v-197.024l74.242 74.243z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.53 286.273 102.626 102.626c3.941 3.941 1.15 10.68-4.424 10.68h-36.086c-9.036 0-17.703-3.59-24.093-9.98l-38.023-38.023z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.23 399.576h-16.582c-9.041 0-17.705-3.586-24.094-9.976l-38.024-38.024v-30.7z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.34 282.661-165.168-165.168c-6.722-6.722-17.621-6.722-24.344 0l-165.168 165.168c-3.941 3.941-1.15 10.68 4.424 10.68h36.086c9.037 0 17.703-3.59 24.093-9.98l106.791-106.791c3.284-3.284 8.608-3.284 11.891 0l106.792 106.792c6.39 6.39 15.056 9.98 24.093 9.98h36.086c5.574-.001 8.365-6.74 4.424-10.681z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.263 283.362 106.791-106.792c3.284-3.284 8.608-3.284 11.891 0l106.792 106.792c6.39 6.39 15.056 9.98 24.093 9.98h20.989l-145.647-145.648c-6.722-6.722-17.621-6.722-24.344 0l-145.647 145.647h20.989c9.036 0 17.703-3.59 24.093-9.979z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.946 176.57 106.792 106.792c6.39 6.39 15.056 9.98 24.093 9.98h36.086c5.574 0 8.365-6.739 4.424-10.68l-165.169-165.169c-3.361-3.361-7.767-5.042-12.172-5.042v61.655c2.152.001 4.304.822 5.946 2.464z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.515 306.463h-61.03c-4.344 0-7.865-3.521-7.865-7.865v-61.03c0-4.344 3.521-7.865 7.865-7.865h61.03c4.344 0 7.865 3.521 7.865 7.865v61.03c0 4.343-3.522 7.865-7.865 7.865z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m264.143 261.673h15.022c2.248 0 4.07-1.822 4.07-4.07v-11.969c0-3.195-2.59-5.786-5.786-5.786h-13.306c-2.248 0-4.07 1.822-4.07 4.07v13.685c0 2.248 1.822 4.07 4.07 4.07z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.927 257.603v-13.685c0-2.248-1.822-4.07-4.07-4.07h-13.306c-3.195 0-5.786 2.59-5.786 5.786v11.969c0 2.248 1.822 4.07 4.07 4.07h15.022c2.248 0 4.07-1.822 4.07-4.07z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.073 275.889v16.358c0 2.248 1.822 4.07 4.07 4.07h13.306c3.195 0 5.786-2.59 5.786-5.786v-14.643c0-2.248-1.822-4.07-4.07-4.07h-15.022c-2.248.001-4.07 1.823-4.07 4.071z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.857 271.819h-15.022c-2.248 0-4.07 1.822-4.07 4.07v14.643c0 3.195 2.59 5.786 5.786 5.786h13.306c2.248 0 4.07-1.822 4.07-4.07v-16.358c0-2.249-1.822-4.071-4.07-4.071z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m285.515 229.704h-30.515v76.759h30.515c4.344 0 7.865-3.521 7.865-7.865v-61.03c0-4.343-3.522-7.864-7.865-7.864z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.62 266.667v31.931c0 4.343 3.521 7.865 7.865 7.865h61.03c4.344 0 7.865-3.521 7.865-7.865v-31.931z",
    fill: "url(#SVGID_28_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m104.47 510h-75.514c-3.518 0-6.37-2.852-6.37-6.37v-25.01c0-3.518 2.852-6.37 6.37-6.37h75.515v37.75z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.53 510h75.515c3.518 0 6.37-2.852 6.37-6.37v-25.01c0-3.518-2.852-6.37-6.37-6.37h-75.515z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.993 510h-81.871c-3.518 0-6.37-2.852-6.37-6.37v-25.01c0-3.518 2.852-6.37 6.37-6.37h81.871z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.007 510h81.871c3.518 0 6.37-2.852 6.37-6.37v-25.01c0-3.518-2.852-6.37-6.37-6.37h-81.871z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m71.195 460.812h-12.138c-7.662 0-13.873-6.211-13.873-13.873v-21.676c0-7.662 6.211-13.873 13.873-13.873h12.139c7.662 0 13.873 6.211 13.873 13.873v21.676c-.001 7.662-6.212 13.873-13.874 13.873z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.294 453.071h-8.336c-5.262 0-9.527-4.265-9.527-9.527v-14.886c0-5.262 4.265-9.527 9.527-9.527h8.336c5.262 0 9.527 4.265 9.527 9.527v14.886c0 5.262-4.265 9.527-9.527 9.527z",
    fill: "url(#SVGID_34_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m450.943 460.812h-12.139c-7.662 0-13.873-6.211-13.873-13.873v-21.676c0-7.662 6.211-13.873 13.873-13.873h12.139c7.662 0 13.873 6.211 13.873 13.873v21.676c0 7.662-6.211 13.873-13.873 13.873z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.042 453.071h-8.336c-5.262 0-9.527-4.265-9.527-9.527v-14.886c0-5.262 4.265-9.527 9.527-9.527h8.336c5.262 0 9.527 4.265 9.527 9.527v14.886c0 5.262-4.265 9.527-9.527 9.527z",
    fill: "url(#SVGID_36_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChurch);
export default __webpack_public_path__ + "static/media/icon-church.3efde5ba011d38697c365d86f584ad00.svg";
export { ForwardRef as ReactComponent };